<!--
  --
  -- 送迎・配車サービス選択コンポーネント
  --
  -->
<template>
  <v-radio-group
    class="mt-0"
    dense hide-details
    v-model="service.value"
  >
    <v-radio
      v-for="item in items"
      :key="item.id"
      :value="item.id"
    >
      <template #label>
        <!-- アイテム名 -->
        <div class="text--primary">{{item.name}}</div>

        <!-- 料金 -->
        <div v-if="item.id !== 0" class="ml-4 text-body-2">
          <span class="text--primary">
            <template v-if="item.price > 0">
              {{item.price | comma}} 円
            </template>
            <template v-else>
              無料
            </template>
          </span>
        </div>
      </template>
    </v-radio>
  </v-radio-group>
</template>

<script>
import * as C from '@/consts'

export default {
  name: 'CPickSelect',
  props: {
    service: {
      type: Object,
      required: true
    }
  },

  computed: {
    items () {
      return [
        { id: C.WAY_NONE, name: 'なし', price: 0 },
        { id: C.WAY_START, name: '出発のみ', price: this.service.oneway },
        { id: C.WAY_RETURN, name: '帰着のみ', price: this.service.oneway },
        { id: C.WAY_ROUND, name: '往復', price: this.service.round }
      ]
    }
  }
}
</script>
